module.exports = __webpack_public_path__ + "img/confirm-btn-check-white.5658d78b.svg";